module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"acquiredAt":"Acquired at","duration":"Duration","chooseDuration":"Choose duration","users":"Users","selectUsers":"Select users"}}')
  delete Component.options._Ctor
}
